/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One numeric column per group. Each column's values are summarised into a five-number summary and drawn as a box with whiskers.`)
};

const es_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una columna numérica por grupo. Los valores de cada columna se resumen en un resumen de cinco números y se dibujan como una caja con bigotes.`)
};

const de_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine numerische Spalte pro Gruppe. Die Werte jeder Spalte werden zu einer Fünf-Zahlen-Zusammenfassung verdichtet und als Box mit Whiskern gezeichnet.`)
};

const nl_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén numerieke kolom per groep. De waarden van elke kolom worden samengevat in een vijfgetallensamenvatting en getekend als een box met whiskers.`)
};

const fr_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une colonne numérique par groupe. Les valeurs de chaque colonne sont résumées en un résumé à cinq nombres et dessinées comme une boîte avec des moustaches.`)
};

const it_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una colonna numerica per gruppo. I valori di ciascuna colonna vengono riassunti in un sommario a cinque numeri e disegnati come una scatola con baffi.`)
};

const pt_br2_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica por grupo. Os valores de cada coluna são resumidos em um resumo de cinco números e desenhados como uma caixa com hastes.`)
};

const pt_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna numérica por grupo. Os valores de cada coluna são resumidos num resumo de cinco números e desenhados como uma caixa com hastes.`)
};

const ja_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループごとに1つの数値列です。各列の値は5つの数値による要約に変換され、ひげ付きの箱として描画されます。`)
};

const zh_box_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每组一列数值。每列的数值会被概括为五数概括，并绘制为带须线的箱子。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_faq_a1", locale)
	if (locale === "en") return en_box_faq_a1(inputs)
	if (locale === "es") return es_box_faq_a1(inputs)
	if (locale === "de") return de_box_faq_a1(inputs)
	if (locale === "nl") return nl_box_faq_a1(inputs)
	if (locale === "fr") return fr_box_faq_a1(inputs)
	if (locale === "it") return it_box_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_box_faq_a1(inputs)
	if (locale === "pt") return pt_box_faq_a1(inputs)
	if (locale === "ja") return ja_box_faq_a1(inputs)
	return zh_box_faq_a1(inputs)
};